import { AssetAllocationId } from '@qvs/core';
import { dynamicAssetBaseMap, staticAssetBaseMap } from '~/shared/helpers/assetBaseMap';

export const staticAssetLabels = new Map<AssetAllocationId, string>(
  [...staticAssetBaseMap].map(([id, data]) => [id, data.label])
);
export const dynamicAssetLabels = new Map<AssetAllocationId, string>(
  [...dynamicAssetBaseMap].map(([id, data]) => [id, data.label])
);
